import * as angular from "angular";
import {IController, ITimeoutService} from "angular";

import {PlanningPanelModel} from "../../models/planning-panel.model";
import {
  PlanningViewSettingsJobsModel,
  PlanningViewSettingsModel,
  PlanningViewSettingsResourcesModel,
  PlanningViewSettingsRoutesModel
} from "../../models/planning-view-settings.model";
import {JobsGroupByEnum} from "../../types/jobs-group-by.enum";
import {PlanningViewMode} from "../../types/planning-view-mode.enum";

export class PlanningProjectDraftPanelComponent implements IController {

  public PlanningViewMode = PlanningViewMode;

  viewMode: string;

  index: number;
  panel: PlanningPanelModel;
  draft: any;
  jobs: any;
  routes: any;
  resources: any;
  panels: PlanningPanelModel[];
  settings: PlanningViewSettingsModel
  selectedJobs: any[];
  selectedJobIds: string[];
  highlightedActivity: any;
  selectedRouteIds: string[];
  isGroupedRoutes?: boolean;
  selectedResourceIds: string[];
  hiddenRouteIds: string[];
  isLoading: boolean;
  jobsGroupByType: JobsGroupByEnum;
  selectedClusterId: string;
  highlightedLeftoverIds: Set<string>;
  highlightedRouteIds: Set<string>;
  onTabChange: Function;
  onPin: Function;
  onSettingsChange: Function;
  onRouteSelect: Function;
  onHiddenRouteIdsChange: Function;
  onMoveActivity: Function;
  onAddStopsToRoute: Function;
  onViewJob: Function;
  onViewGroupedJob: Function;
  onSelectJobs: Function;
  onSelectRoutes: Function;
  onSelectResources: Function;
  onCreateRouteByJobs: Function;
  onCreateRouteByResource: Function;
  onUpdateRouteByJobs: Function;
  onAddJobsToDraft: Function;
  onRemoveJobsFromDraft: Function;
  onMoveToLeftovers: Function;
  onDispatchRoutes: Function;
  onPrintRoutes: Function;
  onPrintLoadingSheetRoutes: Function;
  onChangeResourceSequence: Function;
  onDeleteRoutes: Function;
  onFeedback: Function;
  onLockRouteChange: Function;
  onChangeRouteResource: Function;
  onEditResourceAllocation: Function;
  onReoptimizeRoutes: Function;
  onEditPickingTime: Function;
  onAddResourcesToDraft: Function;
  onRemoveResourcesFromDraft: Function;
  onToggleGroupedRoutes: Function;
  onPanelChange: Function;
  onDuplicate: Function;
  onMinimize: Function;
  onClose: Function;
  onFloat: Function;
  onChangeJobsGroupByType: Function;
  onToggleObligateTimeWindow: Function;
  onToggleLockJobs: Function;
  onDrillDown: Function;
  onContextMenu: Function;
  onReverseJobSplit: Function;
  onUpdateRouteResource: Function;
  onOpenRouteInFloatingTable: Function;
  onOpenResourceInFloatingTable: Function;

  public visibleRouteIds: string[];

  private isResizing: boolean = false;
  private startX: number = 0;
  private startWidth: number = 0;
  public cardWidth: any;
  public onMouseMoveBound: any;
  public onMouseUpBound: any;
  public resizeHandlerBound: any;

  /* @ngInject */
  constructor(private $timeout: ITimeoutService, private $document, private $element) {
  }

  $onInit() {
    this.onMouseMoveBound = this.onMouseMove.bind(this);
    this.onMouseUpBound = this.onMouseUp.bind(this);
    this.resizeHandlerBound = () => {
      this.setCardWidth();
    };

    this.$document.on('mouseup', this.onMouseUpBound);
    this.$document.on('touchend', this.onMouseUpBound);

    // Add window resize event listener
    angular.element(window).on('resize', this.resizeHandlerBound);

    if (!this.draft) {
      this.panel = {};
    }

    this._updateVisibleRoutes();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.viewMode) {
      if (this.viewMode === PlanningViewMode.TABLE) {
        this.$element.find('md-card').css('width', '');
      } else if (this.panel && this.panel.width) {
        this.$element.find('md-card').css('width', this.panel.width + 'px');
      }
      this.$timeout(() => this.setCardWidth(), 0);
    }

    if (changes.hiddenRouteIds || changes.routes) {
      this._updateVisibleRoutes();
    }
  }

  private _updateVisibleRoutes() {
    const hiddenIds = this.hiddenRouteIds || [];
    this.visibleRouteIds = (this.routes || [])
      .map(r => r.id)
      .filter(id => !hiddenIds.includes(id));
  }

  setCardWidth() {
    const cardElement = this.$element.find('md-card')[0];
    if (cardElement) {
        this.cardWidth = cardElement.offsetWidth;
    }
    this.$timeout(() => {}, 0);
  }

  $onDestroy() {
    this.$document.off('mousemove', this.onMouseMoveBound);
    this.$document.off('touchmove', this.onMouseMoveBound);
    this.$document.off('mouseup', this.onMouseUpBound);
    this.$document.off('touchend', this.onMouseUpBound);
    // Remove window resize event listener
    angular.element(window).off('resize', this.resizeHandlerBound);
  }

  $postLink() {
    const el = this.$element.find('.resize-handle')[0];
    if (el) {
      el.addEventListener('mousedown', this.startResize.bind(this));
      el.addEventListener('touchstart', this.startResize.bind(this), { passive: false });
    }

    // Use $timeout to ensure the md-card element is fully rendered
    this.$timeout(() => {
      if (this.viewMode === PlanningViewMode.CARDS) {
        // Apply stored width if available
        if (this.panel && this.panel.width) {
          this.$element.find('md-card').css('width', this.panel.width + 'px');
        }
      }
      // Check initial screen width
      this.setCardWidth();
    }, 0, false);
  }

  startResize(event) {
    event.preventDefault();
    const handle = event.target;
    angular.element(handle).addClass('active');
    this.isResizing = true;
    const e = event.originalEvent || event;
    this.startX = e.touches ? e.touches[0].clientX : e.clientX;
    this.startWidth = this.$element.find('md-card')[0].offsetWidth;

    this.$document.on('mousemove', this.onMouseMoveBound);
    this.$document.on('touchmove', this.onMouseMoveBound);
  }

  onMouseMove(event) {
    if (!this.isResizing) return;
    const e = event.originalEvent || event;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const dx = clientX - this.startX;
    const newWidth = this.startWidth + dx;

    if (newWidth >= 200) {
      this.$element.find('md-card').css('width', newWidth + 'px');
      this.setCardWidth();
    }
  }

  onMouseUp(event) {
    if (!this.isResizing) return;
    this.$element.find('.resize-handle').removeClass('active');
    this.isResizing = false;

    this.$document.off('mousemove', this.onMouseMoveBound);
    this.$document.off('touchmove', this.onMouseMoveBound);

    const cardEl = this.$element.find('md-card')[0];
    if (cardEl) {
        const finalWidth = cardEl.offsetWidth;
        this.setCardWidth();

        const updatedPanel = angular.copy(this.panel);
        updatedPanel.width = finalWidth;

        if (this.onPanelChange) {
          this.onPanelChange({ panel: updatedPanel });
        }
    }
  }

  onPinToggle() {
    const newPinnedState = !this.panel.isPinned;
    if (this.onPin) {
      this.onPin({ panelIndex: this.index, isPinned: newPinnedState });
    }
  }

  onFloatToggle() {
    const newFloatingState = !this.panel.isFloating;
    if (this.onFloat) {
      this.onFloat({ panelIndex: this.index, isFloating: newFloatingState });
    }
  }

  onJobsSettingsChange(jobsSettings: PlanningViewSettingsJobsModel) {
    const settingsCopy = angular.copy(this.settings);
    settingsCopy.jobs = jobsSettings;
    this.onSettingsChange({settings: settingsCopy});
  }

  onPanelSettingsChange(settings: PlanningViewSettingsModel) {
    const settingsCopy = angular.copy(settings);
    this.onSettingsChange({settings: settingsCopy});
  }

  onRoutesSettingsChange(routesSettings: PlanningViewSettingsRoutesModel) {
    const settingsCopy = angular.copy(this.settings);
    settingsCopy.routes = routesSettings;
    this.onSettingsChange({settings: settingsCopy});
  }

  onResourcesSettingsChange(resourcesSettings: PlanningViewSettingsResourcesModel) {
    const settingsCopy = angular.copy(this.settings);
    settingsCopy.resources = resourcesSettings;
    this.onSettingsChange({settings: settingsCopy});
  }

  onRouteDrillDown(routeId: string) {
    const panelCopy = angular.copy(this.panel);
    panelCopy.selectedRouteId = routeId;
    this.onPanelChange({panel: panelCopy});
  }

  onNewPanelDrillDown(routeId) {
    this.onDrillDown({ routeId });
  }

  onCloseRouteDrillDown() {
    const panelCopy = angular.copy(this.panel);
    panelCopy.selectedRouteId = undefined;
    this.onPanelChange({panel: panelCopy});
  }

  onResourceDrillDown(resourceId: string, isFloating?: boolean) {
    if (isFloating) {
      this.onOpenResourceInFloatingTable({resourceId});
    } else {
      const panelCopy = angular.copy(this.panel);
      panelCopy.selectedResourceId = resourceId;
      this.onPanelChange({panel: panelCopy});
    }
  }

  onCloseResourceDrillDown() {
    const panelCopy = angular.copy(this.panel);
    panelCopy.selectedResourceId = undefined;
    this.onPanelChange({panel: panelCopy});
  }

  onOpenRouteFromResource(event) {
    this.onRouteDrillDown(event.routeId);
  }

  onUpdateRouteResourceAction(route, resourceId) {
    this.onUpdateRouteResource({route: route, resourceId: resourceId});
  }

  onVisibleRoutesChange(visibleRouteIds) {
    const updatedHiddenRouteIds = (this.routes || [])
      .map(r => r.id)
      .filter(id => !visibleRouteIds.includes(id));
    this.onHiddenRouteIdsChange({ids: updatedHiddenRouteIds});
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectDraftPanel', {
    bindings: {
      viewMode: '<',
      index: '<',
      draft: '<',
      panel: '<',
      jobs: '<',
      routes: '<',
      resources: '<',
      panels: '<',
      settings: '<',
      selectedJobs: '<',
      selectedJobIds: '<',
      highlightedActivity: '<',
      selectedRouteIds: '<',
      isGroupedRoutes: '<',
      selectedResourceIds: '<',
      hiddenRouteIds: '<',
      isLoading: '<',
      highlightedRouteIds: '<?',
      highlightedLeftoverIds: '<?',
      selectedClusterId: '<?',
      jobsGroupByType: '<?',
      onTabChange: '&',
      onSettingsChange: '&',
      onRouteSelect: '&',
      onHiddenRouteIdsChange: '&',
      onMoveActivity: '&',
      onAddStopsToRoute: '&',
      onViewJob: '&',
      onViewGroupedJob: '&',
      onSelectJobs: '&',
      onSelectRoutes: '&',
      onSelectResources: '&',
      onCreateRouteByJobs: '&',
      onCreateRouteByResource: '&',
      onUpdateRouteByJobs: '&',
      onAddJobsToDraft: '&',
      onRemoveJobsFromDraft: '&',
      onMoveToLeftovers: '&',
      onDispatchRoutes: '&',
      onPrintRoutes: '&',
      onPrintLoadingSheetRoutes: '&',
      onChangeResourceSequence: '&',
      onDeleteRoutes: '&',
      onFeedback: '&',
      onLockRouteChange: '&',
      onChangeRouteResource: '&',
      onEditResourceAllocation: '&',
      onReoptimizeRoutes: '&',
      onEditPickingTime: '&',
      onPreAssignAgent: '&',
      onAddResourcesToDraft: '&',
      onRemoveResourcesFromDraft: '&',
      onToggleGroupedRoutes: '&',
      onPanelChange: '&',
      onPin: '&',
      onDuplicate: '&',
      onMinimize: '&',
      onClose: '&',
      onFloat: '&',
      onChangeJobsGroupByType: '&',
      onToggleObligateTimeWindow: '&',
      onToggleLockJobs: '&',
      onDrillDown: '&',
      onContextMenu: '&',
      onReverseJobSplit: '&',
      onUpdateRouteResource: '&',
      onResetCluster: '&',
      onOpenRouteInFloatingTable: '&',
      onOpenResourceInFloatingTable: '&'
    },
    template: require('./planning-project-draft-panel.html').default,
    controller: PlanningProjectDraftPanelComponent
  });
